export default __webpack_public_path__ + "static/media/ExpandMoreHorizontal.83d19456.svg";